import React, { useState } from "react";
import cn from "classnames";
import { Typography } from "@trussle/external-components";
import { IAccordionItemMobile } from "../../types/IAccordionItem";
import ArrowSvg from "./arrow_back.svg";

import "./styles.scss";

export interface IAccordionSimple {
  accordion: IAccordionItemMobile[];
  title?: string;
  snapScroll?: boolean;
}

export const AccordionSimple: React.FC<IAccordionSimple> = ({
  title, accordion, snapScroll,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className={cn("accordion-simple__container", { "accordion-simple__container--no-snap": !snapScroll })}>
      <Typography variant="h2" classes="accordion-simple__section-title" component="p" id="accordion-simple-section-title">
        {title}
      </Typography>
      <div className={cn("accordion-simple", { "accordion-simple--no-snap": !snapScroll })}>
        {accordion.map((item, index) => (
          <div key={item.title} className={cn("accordion-simple-item", { open: openIndex === index })}>
            <button className="accordion-simple-title" onClick={() => handleClick(index)} type="button">
              <span>{item.title}</span>
              <img src={ArrowSvg} alt="arrow-icon" loading="lazy" />
            </button>
            <div className="accordion-simple-content" data-testid={`accordion-simple-content-${title}`}>
              {item.content}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
